import { render, staticRenderFns } from "./ViewShowPipe.vue?vue&type=template&id=bb25c3d2&scoped=true&"
import script from "./ViewShowPipe.vue?vue&type=script&lang=js&"
export * from "./ViewShowPipe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb25c3d2",
  null
  
)

export default component.exports